import { render, staticRenderFns } from "./RecommendToFriend.vue?vue&type=template&id=64dcee0b&"
import script from "./RecommendToFriend.vue?vue&type=script&lang=js&"
export * from "./RecommendToFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports